import { z } from 'zod';

import { isoDateTimeSchema, ulidSchema } from './primitives';

/**
 * Per-language overrides for the category name. Keys are BCP-47 language codes (e.g. `'pap'`, `'nl'`).
 * English is always the primary/fallback; only alternate-language overrides are stored here.
 */
export const menuCategoryTranslationSchema = z.object({
  name: z.string().min(1).max(120).optional(),
});
export type MenuCategoryTranslation = z.infer<typeof menuCategoryTranslationSchema>;

export const menuCategoryTranslationsSchema = z.record(z.string(), menuCategoryTranslationSchema);
export type MenuCategoryTranslations = z.infer<typeof menuCategoryTranslationsSchema>;

export const menuCategoryEntitySchema = z.object({
  menuCategoryId: ulidSchema,
  restaurantId: ulidSchema,
  name: z.string().min(1).max(120),
  sortOrder: z.number().int().nonnegative(),
  translations: menuCategoryTranslationsSchema.optional(),
  createdAt: isoDateTimeSchema,
  updatedAt: isoDateTimeSchema,
});
export type MenuCategoryEntity = z.infer<typeof menuCategoryEntitySchema>;

export const menuCategoryOwnerSchema = menuCategoryEntitySchema;
export type MenuCategoryOwner = z.infer<typeof menuCategoryOwnerSchema>;
